(function () {
  'use strict';
  function spotifyTrack(raw) {
    try {
      const url = new URL(raw.trim());
      if (url.protocol !== 'https:' || url.hostname !== 'open.spotify.com' || url.username || url.password || url.port) return null;
      const match = url.pathname.match(/^\/(?:intl-[a-z]{2}\/)?track\/([A-Za-z0-9]{22})\/?$/);
      return match ? { id: match[1], url: 'https://open.spotify.com/track/' + match[1] } : null;
    } catch (_) { return null; }
  }
  if (typeof module !== 'undefined') module.exports = { spotifyTrack };
  if (typeof window === 'undefined' || !window.customElements || customElements.get('jw-music')) return;
  class JwMusic extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.urls = [];
      this.words = JSON.parse(this.querySelector('[data-words]').textContent);
      this.form = this.querySelector('form');
      this.select = this.querySelector('[data-variant]');
      this.link = this.querySelector('[data-spotify]');
      this.iframe = this.querySelector('[data-player]');
      const on = (el, event, fn) => el.addEventListener(event, fn, { signal: this.abort.signal });
      on(this.select, 'change', () => this.changeVariant());
      this.querySelectorAll('[data-choice]').forEach(button => on(button, 'click', () => {
        this.select.value = button.dataset.choice;
        this.changeVariant();
      }));
      on(this.querySelector('[data-find]'), 'click', () => {
        const title = this.querySelector('[data-title]').value.trim();
        const artist = this.querySelector('[data-artist]').value.trim();
        window.open('https://open.spotify.com/search/' + encodeURIComponent([title, artist].filter(Boolean).join(' ') || 'music'), '_blank', 'noopener,noreferrer');
      });
      on(this.link, 'input', () => {
        this.link.setCustomValidity('');
        this.iframe.removeAttribute('src');
        this.querySelector('[data-player-wrap]').hidden = true;
      });
      on(this.querySelector('[data-listen]'), 'click', () => this.loadSpotify());
      this.querySelectorAll('[data-photo]').forEach(input => on(input, 'change', () => this.photos()));
      on(this.form, 'submit', event => this.submit(event));
      on(this.form, 'input', () => this.recap());
      this.setupSongPicker(on);
      this.changeVariant();
    }
    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.stopSongSearch) this.stopSongSearch();
      this.urls.forEach(url => URL.revokeObjectURL(url));
      this.ready = false;
    }
    setupSongPicker(on) {
      const dialog = this.querySelector('[data-song-dialog]');
      if (!dialog) return;
      const catalog = JSON.parse(this.querySelector('[data-song-catalog]').textContent);
      const search = dialog.querySelector('[data-song-search]');
      const results = dialog.querySelector('[data-song-results]');
      const player = dialog.querySelector('[data-dialog-player]');
      let tab = 'suggestions';
      const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const valid = t => t && /^[A-Za-z0-9]{22}$/.test(t.id) && typeof t.title === 'string' && typeof t.artist === 'string';
      const recent = () => { try { const tracks = JSON.parse(sessionStorage.getItem('jw-song-recent-v2') || '[]'); return Array.isArray(tracks) ? tracks.filter(valid).slice(0,8) : []; } catch (_) { return []; } };
      let found = catalog, timer, controller, generation = 0, blockedUntil = 0;
      const cache = new Map();
      const status = dialog.querySelector('[data-song-empty]');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      const message = text => { status.textContent = text; status.hidden = false; };
      const stop = () => { clearTimeout(timer); generation++; if (controller) controller.abort(); results.removeAttribute('aria-busy'); };
      this.stopSongSearch = stop;
      const render = () => {
        results.replaceChildren();
        const filtered = tab === 'recent' ? recent().filter(t => normalize(t.title + ' ' + t.artist).includes(normalize(search.value.trim()))) : found;
        status.textContent = this.words.no_song;
        status.hidden = filtered.length > 0;
        filtered.forEach(track => {
          const row = document.createElement('div'); row.className = 'jw-song-row';
          const choose = document.createElement('button'); choose.type = 'button'; choose.className = 'jw-song-select';
          if (typeof track.image === 'string' && /^https:\/\/(?:i\.scdn\.co|image-cdn-[a-z]+\.spotifycdn\.com)\//.test(track.image)) { const img = document.createElement('img'); img.src = track.image; img.alt = ''; img.width = 64; img.height = 64; img.loading = 'lazy'; choose.append(img); }
          const text = document.createElement('span'); const title = document.createElement('strong'); const artist = document.createElement('small'); title.textContent = track.title; artist.textContent = track.artist; text.append(title,artist); choose.append(text);
          choose.addEventListener('click', () => {
            this.querySelector('[data-title]').value = track.title;
            this.querySelector('[data-artist]').value = track.artist;
            this.link.value = 'https://open.spotify.com/track/' + track.id;
            this.link.setCustomValidity(''); this.iframe.removeAttribute('src'); this.querySelector('[data-player-wrap]').hidden = true;
            try { sessionStorage.setItem('jw-song-recent-v2',JSON.stringify([track,...recent().filter(t=>t.id!==track.id)].slice(0,8))); } catch (_) {}
            this.recap(); dialog.close();
          });
          const play = document.createElement('button'); play.type = 'button'; play.className = 'jw-song-play'; play.textContent = '▷'; play.setAttribute('aria-label', this.querySelector('[data-listen]').textContent.trim() + ' ' + track.title);
          play.addEventListener('click', () => { player.src = 'https://open.spotify.com/embed/track/' + track.id; player.hidden = false; });
          row.append(choose,play); results.append(row);
        });
      };
      const update = () => {
        stop();
        const query = search.value.trim().slice(0,150);
        if (tab === 'recent') { render(); return; }
        if (!query) { found = catalog; render(); return; }
        found = []; render();
        if (query.length < 2) { message(this.words.search_min); return; }
        if (Date.now() < blockedUntil) { message(this.words.search_busy); return; }
        const key = normalize(query);
        if (cache.has(key)) { found = cache.get(key); render(); return; }
        message(this.words.search_loading);
        results.setAttribute('aria-busy', 'true');
        const request = generation;
        timer = setTimeout(async () => {
          controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 15000);
          try {
            const response = await fetch('https://empty-bush-c14b.alp-tunisie.workers.dev/search?q=' + encodeURIComponent(query), {signal: controller.signal, credentials: 'omit'});
            if (request !== generation) return;
            if (response.status === 429) {
              const retry = Number(response.headers.get('Retry-After'));
              blockedUntil = Date.now() + (Number.isFinite(retry) && retry > 0 ? Math.max(5,retry) : 30) * 1000;
              throw new Error('rate');
            }
            if (!response.ok) throw new Error('search');
            const data = await response.json();
            if (request !== generation) return;
            if (!Array.isArray(data.tracks)) throw new Error('search');
            found = data.tracks.filter(valid).slice(0,10);
            if (cache.size >= 30) cache.delete(cache.keys().next().value);
            cache.set(key,found); render();
          } catch (error) {
            if (request === generation) message(error.message === 'rate' ? this.words.search_busy : this.words.search_error);
          } finally {
            clearTimeout(timeout);
            if (request === generation) results.removeAttribute('aria-busy');
          }
        },350);
      };
      on(this.querySelector('[data-open-picker]'), 'click', () => { update(); dialog.showModal(); search.focus(); });
      on(dialog.querySelector('[data-close-picker]'), 'click', () => dialog.close());
      on(dialog, 'close', () => { stop(); player.removeAttribute('src'); player.hidden = true; this.querySelector('[data-open-picker]').focus(); });
      on(search, 'input', update);
      dialog.querySelectorAll('[data-song-tab]').forEach(button => on(button, 'click', () => { tab=button.dataset.songTab; dialog.querySelectorAll('[data-song-tab]').forEach(b=>b.setAttribute('aria-pressed',String(b===button))); update(); }));
      on(dialog.querySelector('[data-song-manual]'), 'click', () => { dialog.close(); this.querySelector('[data-title]').focus(); });
    }
    recap() {
      const values = [['model', this.select.selectedOptions[0]?.textContent], ['names', this.querySelector('[data-names]')?.value], ['song', this.querySelector('[data-title]')?.value], ['artist', this.querySelector('[data-artist]')?.value]];
      values.forEach(([key, value]) => {
        const el = this.querySelector('[data-recap-' + key + ']');
        if (el) el.textContent = value?.trim() || '—';
      });
    }
    changeVariant() {
      const opt = this.select.selectedOptions[0];
      if (!opt) return;
      const style = opt.dataset.style;
      const photoCount = {mosaique:9,quatuor:4,duo:2}[style] || 1;
      const calendar = style === 'calendrier';
      const hero = this.querySelector('[data-hero]');
      hero.src = opt.dataset.image;
      hero.alt = opt.textContent;
      const preview = this.querySelector('[data-model-preview]');
      if (preview) { preview.src = opt.dataset.image; preview.alt = opt.textContent.trim(); }
      const supplierStyle = this.querySelector('[data-supplier-style]');
      if (supplierStyle) supplierStyle.value = {classique:'15',vinyle:'8',calendrier:'3',mosaique:'7','plein-format':'1',quatuor:'4',duo:'5',hommage:'13'}[style] || '';
      this.querySelector('[data-price]').textContent = opt.dataset.price;
      this.querySelector('[data-model]').value = opt.dataset.sku;
      this.querySelector('[data-style-property]').value = opt.textContent.trim();
      this.querySelectorAll('[data-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.choice === opt.value)));
      this.querySelectorAll('[data-extra-photo]').forEach(box => {
        const active = Number(box.dataset.extraPhoto || 2) <= photoCount;
        box.hidden = !active;
        const input = box.querySelector('input');
        input.disabled = !active;
        input.required = active;
        if (!active) { input.value = ''; input.setCustomValidity(''); }
      });
      const dates = this.querySelector('[data-calendar]');
      dates.hidden = !calendar;
      dates.querySelectorAll('input').forEach(input => {
        input.disabled = !calendar;
        input.required = calendar;
      });
      this.querySelector('[data-photo-help]').textContent = style === 'hommage' ? this.words.portrait_photo : photoCount === 9 ? this.words.nine_photos : photoCount === 4 ? this.words.four_photos : photoCount === 2 ? this.words.two_photos : this.words.one_photo;
      const memorial = this.querySelector('[data-memorial-note]');
      if (memorial) memorial.hidden = style !== 'hommage';
      const inscription = this.querySelector('[data-hommage-inscription]');
      if (inscription) inscription.disabled = style !== 'hommage';
      const nameWrap = this.querySelector('[data-names-wrap]');
      if (nameWrap) {
        const names = nameWrap.querySelector('input');
        const acceptsNames = !['quatuor','duo','hommage'].includes(style);
        nameWrap.hidden = !acceptsNames; names.disabled = !acceptsNames; names.required = acceptsNames;
        const recapName = this.querySelector('[data-recap-names]');
        if (recapName) recapName.parentElement.hidden = !acceptsNames;
      }
      const buy = this.querySelector('[data-buy]');
      buy.disabled = opt.dataset.available !== 'true' || Number(opt.dataset.cents) <= 0;
      buy.textContent = buy.disabled ? this.words.unavailable : this.words.add;
      this.photos();
      this.recap();
    }
    photos() {
      this.urls.forEach(url => URL.revokeObjectURL(url));
      this.urls = [];
      const thumbs = this.querySelector('[data-photo-previews]');
      thumbs.replaceChildren();
      this.querySelectorAll('[data-photo]:not(:disabled)').forEach(input => {
        input.setCustomValidity('');
        const file = input.files[0];
        if (!file) return;
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
          input.setCustomValidity(this.words.file_error);
          input.reportValidity();
          return;
        }
        const src = URL.createObjectURL(file);
        this.urls.push(src);
        const image = document.createElement('img');
        image.src = src;
        image.alt = file.name;
        image.width = 96;
        image.height = 96;
        thumbs.append(image);
      });
    }
    loadSpotify() {
      const track = spotifyTrack(this.link.value);
      this.link.setCustomValidity(track ? '' : this.words.spotify_error);
      if (!track) { this.link.reportValidity(); return; }
      this.link.value = track.url;
      this.iframe.src = 'https://open.spotify.com/embed/track/' + track.id;
      this.querySelector('[data-player-wrap]').hidden = false;
    }
    async submit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const opt = this.select.selectedOptions[0];
      if (!opt || opt.dataset.available !== 'true' || Number(opt.dataset.cents) <= 0 || this.busy) return;
      const track = this.link.value.trim() ? spotifyTrack(this.link.value) : null;
      this.link.setCustomValidity(this.link.value.trim() && !track ? this.words.spotify_error : '');
      this.photos();
      if (!this.form.reportValidity()) return;
      if (track) this.link.value = track.url;
      const status = this.querySelector('[data-status]');
      if (this.dataset.preview === 'true') {
        status.textContent = this.words.preview_only;
        return;
      }
      const button = this.querySelector('[data-buy]');
      this.busy = true;
      button.disabled = true;
      status.textContent = this.words.adding;
      try {
        const response = await fetch(this.dataset.addUrl, { method: 'POST', body: new FormData(this.form), headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.words.cart_error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || this.words.cart_error;
        this.busy = false;
        button.disabled = false;
      }
    }
  }
  customElements.define('jw-music', JwMusic);
}());



